import type { CharacterConfig } from "../types";

/**
 * Warrior - The balanced starting character
 *
 * Base stats: 30 HP, 6 ATK, 2 Armor
 * Starting skill: Attack Lv1
 * Visual: Uses the default player sprite
 */
export const warriorConfig: CharacterConfig = {
  id: "warrior",
  name: "Warrior",
  description: "A balanced fighter with solid defenses and reliable damage.",
  sprite: "player",
  stats: {
    maxHp: 30,
    atk: 6,
    armor: 2,
  },
  startingSkills: {
    attack: 1,
  },
};
